import React from 'react'

interface ProfileIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ProfileIcon: React.FC<ProfileIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Profile icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M19.61 19.592A10.717 10.717 0 0112 22.75a10.72 10.72 0 01-7.813-3.366c.064-.331.14-.63.233-.909l.008-.023.007-.024c.09-.317.25-.666.46-1.049.191-.334.41-.617.64-.852.26-.225.557-.414.87-.544a3.205 3.205 0 011.105-.21c.016.008.04.02.072.039.05.028.115.068.2.123.286.197.588.392.92.599.403.259.897.46 1.363.63l.029.01.029.008a6.02 6.02 0 001.746.28c.616 0 1.188-.11 1.746-.28l.022-.006.02-.007c.515-.18.982-.38 1.38-.635l.167-.104.014-.01c.241-.149.514-.319.754-.496a3.66 3.66 0 01.257-.15c.403.006.783.084 1.112.212.335.132.623.32.85.53.236.238.461.528.657.871l.006.01.006.011c.198.332.346.678.444 1.02l.006.024.008.023c.12.363.222.729.292 1.117zm.92-1.05a10.867 10.867 0 00-.132-.426 5.41 5.41 0 00-.562-1.292 5.322 5.322 0 00-.853-1.126 3.85 3.85 0 00-1.227-.77 4.351 4.351 0 00-1.581-.293c-.229 0-.437.084-.853.355a10.41 10.41 0 01-.727.48l-.167.103c-.292.188-.666.355-1.144.521-.479.146-.937.23-1.415.23a4.89 4.89 0 01-1.414-.23c-.458-.166-.853-.333-1.144-.52a22.867 22.867 0 01-.895-.584c-.416-.271-.624-.354-.853-.354-.561 0-1.102.104-1.58.291a4.372 4.372 0 00-1.228.771 5.322 5.322 0 00-.853 1.126c-.229.417-.437.854-.561 1.292a7.11 7.11 0 00-.057.178A10.701 10.701 0 011.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12c0 2.462-.828 4.73-2.22 6.543zM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-14.525-.047l-.008-.008c-.671-.672-1-1.465-1-2.404 0-.94.329-1.732 1-2.403.67-.67 1.462-1 2.421-1 .938 0 1.727.327 2.396 1.01l.008.008c.671.671 1 1.464 1 2.403 0 .94-.329 1.732-1 2.404-.672.671-1.464 1-2.403 1-.959 0-1.746-.33-2.414-1.01zM11.89 5c1.243 0 2.324.45 3.207 1.352.883.883 1.334 1.964 1.334 3.207 0 1.244-.45 2.325-1.334 3.208-.883.883-1.964 1.334-3.207 1.334-1.262 0-2.343-.451-3.226-1.352-.883-.883-1.334-1.964-1.334-3.208 0-1.243.45-2.324 1.334-3.207C9.546 5.45 10.627 5 11.889 5z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default ProfileIcon
